import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-warranty-info',
  templateUrl: './warranty-info.component.html',
  styleUrls: ['./warranty-info.component.scss']
})
export class WarrantyInfoComponent implements OnInit {

  isMobile:boolean = false;

  constructor(private breakPointObserver: BreakpointObserver ) {

   }

  ngOnInit(): void {
    this.breakPoint();
  }

  breakPoint(){
    this.breakPointObserver.observe([Breakpoints.XSmall]).subscribe( result => {
      if(result.matches){
        this.isMobile = true;
      }else{ 
        this.isMobile = false;
      }
    });
  }

}
